import React from 'react';

import clientsImg from '../../images/clients.svg';
import premiumsImg from '../../images/premiums.svg';
import policiesImg from '../../images/policies.svg';

import ItemInfo from './ItemInfo';
import style from './ClientInfo.module.css';

const ClientInfo = React.memo(({ policies = -1, premiums = -1, clients = -1 }) => {
  return (
    <section className={style.info}>
      <ItemInfo
        show={policies !== -1}
        text="Policies"
        img={policiesImg}
        value={`${policies}`}
      />
      <ItemInfo
        show={premiums !== -1}
        text="Premiums"
        img={premiumsImg}
        value={`${premiums}`}
      />
      <ItemInfo
        show={clients !== -1}
        text="Clients"
        img={clientsImg}
        value={`${clients}`}
      />
    </section>
  );
});

ClientInfo.propTypes = {};

export default ClientInfo;
